import api from "../api/axios"

export const getPacks = async () => {
  const res = await api.get("/packs")
  return res.data
}

export const getPack = async (id) => {
  const res = await api.get(`/packs/${id}`)
  return res.data
}

export const createPack = async (data) => {
  const res = await api.post("/packs", data)
  return res.data
}

export const updatePack = async (id, data) => {
  const res = await api.put(`/packs/${id}`, data)
  return res.data
}

export const deletePack = async (id) => {
  const res = await api.delete(`/packs/${id}`)
  return res.data
}
